import { formatDate, parseDateInput, serializeDateInput, t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { CalendarIcon } from 'lucide-react';
import { type ComponentProps, useState } from 'react';
import { Button } from './button';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

export const DateInput = ({
  value,
  onChange,
  placeholder,
  ...props
}: Omit<ComponentProps<typeof Button>, 'value' | 'onChange'> & {
  value?: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
}) => {
  const locale = useLocale();
  const [open, setOpen] = useState(false);
  const selected = parseDateInput(value);
  return (
    <Popover onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <Button
          {...props}
          className="w-full justify-between font-normal"
          type="button"
          variant="outline"
        >
          {selected ? formatDate(selected, locale) : value || placeholder || '—'}
          <CalendarIcon className="ms-2 size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-2">
        <Calendar
          captionLayout="dropdown"
          defaultMonth={selected}
          endMonth={new Date(2100, 11)}
          mode="single"
          onSelect={(date) => {
            onChange(date ? serializeDateInput(date) : '');
            setOpen(false);
          }}
          selected={selected}
          startMonth={new Date(1900, 0)}
        />
        <Button
          className="w-full"
          onClick={() => {
            onChange('');
            setOpen(false);
          }}
          type="button"
          variant="ghost"
        >
          {t('workspace.delete')}
        </Button>
      </PopoverContent>
    </Popover>
  );
};
